import { Modal } from 'react-responsive-modal'
import styled from 'styled-components'
import media from 'styled-media-query'

export const Container = styled(Modal)``

export const Content = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;

  width: 100%;
  min-width: 400px;

  ${media.lessThan('medium')`
    min-width: auto;
  `};
`

export const Header = styled.header`
  display: flex;
  gap: 10rem;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  padding-bottom: 1.5rem;

  border-bottom: 2px solid ${(props) => props.theme.colors.secondary};

  ${media.lessThan('medium')`
    gap: 2rem;
  `};

  .right {
    display: flex;
    align-items: center;

    button svg {
      width: 2rem;
      height: 2rem;

      color: ${(props) => props.theme.colors.text.cards};
    }
  }
`

export const Form = styled.form`
  display: flex;
  gap: 2rem;
  flex-direction: column;

  width: 100%;
`

export const Title = styled.h1`
  font-weight: bold;
  font-size: 1.8rem;

  color: ${(props) => props.theme.colors.text.cards};
`

export const Description = styled.span`
  font-weight: 400;
  font-size: 1.5rem;

  color: ${(props) => props.theme.colors.text.cards};

  opacity: 0.9;
`

export const Col = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;
`

export const Label = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 1rem;

  font-weight: 500;
  font-size: 1.5rem;

  color: ${(props) => props.theme.colors.text.cards};
`

export const Input = styled.input`
  display: block;
  width: 100%;
  height: calc(4rem + 2px);
  padding: 1rem 1.2rem;
  font-size: 1.5rem;
  color: #5e5e5e;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  background-clip: padding-box;
  border: 2px solid #76cdc6;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: 0.4s;

  outline: none;

  &:hover,
  &:focus {
    border: 2px solid #76cdc6;
  }

  &.is-invalid {
    border-color: ${(props) => props.theme.colors.red};
  }
`

export const Error = styled.span`
  font-size: 1.5rem;
  color: ${(props) => props.theme.colors.red};
  margin-top: 0.5rem;
`

export const Buttons = styled.div`
  display: flex;
  gap: 1rem;

  button {
    display: flex;
    justify-content: center;
    align-items: center;

    flex: 1;

    min-height: 4.5rem;
    height: 100%;

    background: ${(props) => props.theme.colors.secondary};
    border-radius: 0.5rem;

    padding: 1rem;

    font-weight: 700;
    font-size: 1.8rem;

    color: ${(props) => props.theme.colors.text.cards};

    &.red {
      background: ${(props) => props.theme.colors.red};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`
